import { render, staticRenderFns } from "./PaymentMethodsAndDelivery.vue?vue&type=template&id=1c56500e"
import script from "./PaymentMethodsAndDelivery.vue?vue&type=script&lang=js"
export * from "./PaymentMethodsAndDelivery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports